<div class="container-fluid">
  <div class="row">
    <div class="col-xl-7" [ngStyle]="{'background-image': 'url(assets/images/login/2.jpg)',
                                     'background-size': 'cover',
                                     'background-position': 'center center',
                                     'display': 'block'}">
      <img class="bg-img-cover bg-center d-none" src="assets/images/login/2.jpg" alt="looginpage">
    </div>
    <div class="col-xl-5 p-0">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" href="#">
              <img class="img-fluid for-light" src="assets/images/logo/login.png" style="    height: 204px;
    margin-bottom: -86px;" alt="looginpage">
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" style="    height: 204px;
    margin-bottom: -86px;" alt="looginpage">
            </a>
          </div>
          <div class="login-main"> 
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Sign in to account</h4>
              <p>Enter your email & password to login</p>
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" required="" placeholder="app@yourmail.com"  formControlName="email">
              </div>
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" name="login[password]" required="" placeholder="*********">
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox">
                  <label class="text-muted" for="checkbox1">Remember password</label>
                </div>
                <a [routerLink]="'/auth/forget-password'" class="link">Forgot password?</a>
                <button
                class="btn btn-primary btn-block"
                [ngStyle]="{'background-color': !loginForm.valid ? '#A389D2' : ''}"
                [disabled]="!loginForm.valid"
                (click)="login()"
                type="button"
              >
                <span>Login</span>
              </button>
              </div>

              <p class="mt-4 mb-0">Don't have account?
                <a (click)="register()" class="ml-2">Create Account</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>